<script>
  // Import Svelte
  import { onMount, onDestroy, createEventDispatcher } from "svelte";
  import { log, announce } from "./Logging.svelte";
  
  // Properties and defaults
  let a = "c:Connections"; // Log name
  export let user;
  export let db;
  let connectionSubscription = null;
  const dispatch = createEventDispatcher();
  let connection = {
    roomName: null,
    key: null,
    destination: null,
    passphrase: null
  };

  function initProcess() {
    console.log(a, ": initProcess");
    ////////////////////////////
    // subscribe to connections
    ////////////////////////////
    connectionSubscription = db
      .collection("Connections")
      .doc(user.uid)
      .onSnapshot(
        function(snapshot) {
          // A brand-new account has no Connections doc until it is first matched.
          let data = snapshot.data() || {};
          connection.roomName = data.room || null;
          connection.key = data.key;
          connection.destination = data.destination;
          connection.passphrase = data.passphrase;
          console.log(a, ": rk", data);
        },
        function(error) {
          console.log(a, ": Connection Listen Error", error);
        }
      );
  }

  function destroyProcess() {
    console.log(a, ": destroyProcess");
    // unsubscribe from connections
    if (connectionSubscription) {
      connectionSubscription();
      connectionSubscription = null;
      console.log(a, ": SO_Step - Unsubscribed connections");
    } else {
      connectionSubscription = null;
      console.log("SO_Step - Already unsubscribed connections");
    }
  }

  onMount(() => {
    announce("Connections Mounted");
    let b = "f:onMount";
    if (user) {
      initProcess();
    } else {
      console.log(a, b, ": Error user is not set");
    }
    return () => {
      destroyProcess();
    };
  });
</script>
<slot {connection} />
